module.exports = __webpack_public_path__ + "img/volume-off-fill.a43d8f86.svg";